<template>
    <div>
        <div>
            <h3 class="font-light font-heading mb-2 hidden md:flex items-center gap-2 px-4 py-2 bg-2025-light-beige">
                <span>Sort</span>
            </h3>

            <div>
                <ul>
                    <li
                        v-for="option in options"
                        :key="option.id"
                    >
                        <CategoryFilterOption
                            :active="sortBy === option.id"
                            @click="sort(option.id)"
                        >
                            {{ option.name }}
                        </CategoryFilterOption>
                    </li>
                </ul>
            </div>

            <div
                v-show="sortBy !== 'recommended'"
                class="flex items-center cursor-pointer mt-2"
                @click="reverseOrder"
            >
                <span class="text-primary text-sm">
                    <template v-if="sortBy === 'created_at'">
                        {{ sortDirection === 'asc' ? 'Oldest to newest' : 'Newest to oldest' }}
                    </template>
                    <template v-else>
                        {{ sortDirection === 'asc' ? 'Lowest to highest' : 'Highest to lowest' }}
                    </template>

                </span>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryFilterOption from '@/components/CategoryFilterOption.vue';

export default {

    components: {
        CategoryFilterOption,
    },

    props: {
        sortBy: {
            type: String,
            required: true,
        },
        sortDirection: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            options: [
                {
                    id: 'recommended',
                    name: 'Recommended',
                },
                {
                    id: 'popularity',
                    name: 'Popularity',
                },
                {
                    id: 'price',
                    name: 'Price',
                },
                {
                    id: 'created_at',
                    name: 'New',
                },
            ],
        };
    },

    methods: {
        sort(sortString) {
            this.$emit('change:sort-by', sortString);
        },
        reverseOrder() {
            this.$emit('change:sort-direction', this.sortDirection === 'asc' ? 'desc' : 'asc');
        },
    },

};
</script>

<style lang="scss" scoped>
.active {
    @apply text-primary;
}
.sort-direction-icon {
    @apply cursor-pointer text-primary transition-fast w-5;
    &:hover {
        @apply opacity-75;
    }
    &--rotated {
        transform: rotateX(180deg);
    }
}
</style>
